exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panels--3DvYESCXXegmKZwutuP7Zq {\n  position: relative;\n  height: 75px;\n}\n", ""]);

// exports
exports.locals = {
	"loaderContainer": "panels--3DvYESCXXegmKZwutuP7Zq",
	"loaderContainer": "panels--3DvYESCXXegmKZwutuP7Zq"
};